import { DropdownMenu, Loader } from '@octopus-do/octopus-storybook'
import { Cog } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { forwardRef } from 'react'

import { preventDefaultHandler, stopPropagation } from '@/helpers'
import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  loading: boolean
  onOpen: () => void
}

export const MenuButton = forwardRef<HTMLButtonElement, Props>(
  ({ loading, onOpen }, ref) => {
    const { open, active } = DropdownMenu.useTrigger()
    const onClick = (ev: React.MouseEvent<HTMLButtonElement>) => {
      preventDefaultHandler(ev)
      stopPropagation(ev)
      onOpen()
      open()
    }

    const className = clsJoin(
      css.project_actions_menu_button,
      active && css.active
    )

    return (
      <button
        ref={ref}
        onClick={onClick}
        className={className}
        disabled={loading}
        type="button"
      >
        {loading ? <Loader /> : <Cog />}
      </button>
    )
  }
)
